import { Fragment, useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useSessionStorage } from "react-use";
import Swal from "sweetalert2";
import { getRequestByAuth } from "../../../../../function/helper";
import useSharedData from "../../../../../hooks/useSharedData";
import NewAddress from "../../../../components/addresses/NewAddress";
import SearchAddress from "../address/searchAddress/SearchAddress";

function Address({ senderOrgetter }) {
  const addressTemplate = {
    type: "",
    name: "",
    family: "",
    compony: "",
    nationalCode: "",
    phone: "",
    tel: "",
    postCode: "",
    province_name: { faName: "" },
    city_name: { faName: "" },
    area: { faName: "" },
    address: "",
  };

  const [address, setAddress] = useSessionStorage(
    senderOrgetter === 0 ? "senderAddress" : "getterAddress",
    addressTemplate
  );

  const { isAgent } = useSharedData();

  const [senderOrGetterPick, setSenderOrGetterPick] = useState(-1);
  const [searchAddressModal, setSearchAddressModal] = useState(-1);
  const [mySelf, setMySelf] = useState(true);
  const [showModalWarning, setShowModalWarning] = useState(false);

  const getAddress = async () => {
    const response = await getRequestByAuth("/address/v1/default/address");

    if (response && response.status === 200) {
      setAddress(() => response.result);
    } else if (response && response.status === 401) {
      Swal.fire({
        icon: "warning",
        title: "نیاز به ورود مجدد",
        confirmButtonText: "باشه",
      }).then(() => {
        window.location.href = "/login";
      });
    }
  };

  useEffect(() => {
    if (
      isAgent === false &&
      senderOrgetter === 0 &&
      mySelf === true &&
      address.id === undefined
    ) {
      getAddress();
    }
  }, [mySelf]);

  const handleRadioChange = ({ target: { value } }) => {
    if (value === "mySelft") {
      setAddress(() => addressTemplate);
      setMySelf(() => true);
    } else {
      setAddress(() => addressTemplate);
      setMySelf(() => false);
      setShowModalWarning(true);
    }
  };

  return (
    <div>
      <Col className="sender">
        <Row>
          <p className="title-style">
            {senderOrgetter === 0 ? "فرستنده" : "گیرنده"}
          </p>
        </Row>
        <div
          className={
            "d-flex align-items-center flex-wrap justify-content-around" +
            (senderOrgetter === 0 && isAgent === false ? " my-3" : "")
          }
        >
          {isAgent === false && senderOrgetter === 0 && (
            <Fragment>
              <div className="d-flex flex-row align-items-center">
                <input
                  type="radio"
                  style={{
                    width: "22px",
                    margin: "3px",
                  }}
                  id="ewrmsdfsldf"
                  value="mySelft"
                  name="fav_language"
                  onClick={e => handleRadioChange(e)}
                  checked={mySelf === true}
                  className="c-pointer"
                />
                <label
                  htmlFor="ewrmsdfsldf"
                  className="c-pointer user-select-none"
                >
                  خودم
                </label>
              </div>
              <div className="d-flex flex-row align-items-center">
                <input
                  type="radio"
                  style={{
                    width: "22px",
                    margin: "3px",
                  }}
                  onClick={e => handleRadioChange(e)}
                  name="fav_language"
                  value="others"
                  checked={mySelf === false}
                  id="seasd4wqer4"
                  className="c-pointer"
                />
                <label
                  htmlFor="seasd4wqer4"
                  className="c-pointer user-select-none"
                >
                  دیگران
                </label>
              </div>
            </Fragment>
          )}

          {(isAgent === true || senderOrgetter === 1) && (
            <Fragment>
              <Col className="d-flex align-items-center justify-content-center">
                <button
                  className="btn-orange-header-button "
                  onClick={() => setSenderOrGetterPick(() => senderOrgetter)}
                >
                  ثبت آدرس جدید
                </button>
              </Col>
              <Col className="d-flex align-items-center justify-content-center">
                <div>
                  <button
                    type="button"
                    onClick={() => setSearchAddressModal(senderOrgetter)}
                    className="header-button blueShadow blueBackground"
                    style={{ width: "200px" }}
                  >
                    <span>انتخاب آدرس قبلی </span>
                    <span>{senderOrgetter === 0 ? "فرستنده" : "گیرنده"}</span>
                  </button>
                </div>
              </Col>
            </Fragment>
          )}
        </div>

        <hr className="titre-line" />

        <Form.Group>
          <Form.Label>
            نوع: <span className="text-danger">*</span>
          </Form.Label>
          <Form.Select
            className="select"
            name=""
            value={address.type}
            readOnly={true}
          >
            <option value="0" name="">
              حقیقی
            </option>
            <option value="1" name="">
              حقوقی
            </option>
          </Form.Select>
        </Form.Group>

        {address.type !== 1 && (
          <Fragment>
            <Form.Group>
              <Form.Label>
                نام:<span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name=""
                value={address.name ?? ""}
                readOnly={true}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>
                نام خانوادگی:<span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name=""
                value={address.family ?? ""}
                readOnly={true}
              />
            </Form.Group>
          </Fragment>
        )}

        {address.type === 1 && (
          <Form.Group>
            <Form.Label>
              نام شرکت:<span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              name=""
              value={address.compony ?? ""}
              readOnly={true}
            />
          </Form.Group>
        )}

        <Form.Group>
          <Form.Label>
            <span>{address.type === 0 ? "کد ملی" : "شناسه ملی"}: </span>
            <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            name=""
            value={address.nationalCode ?? ""}
            readOnly={true}
          />
        </Form.Group>

        <Form.Group>
          <Form.Label>
            موبایل:<span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            name=""
            value={address.phone ?? ""}
            readOnly={true}
          />
        </Form.Group>

        <Form.Group>
          <Form.Label> تلفن:</Form.Label>
          <Form.Control
            type="text"
            name=""
            value={address.tel ?? ""}
            readOnly={true}
          />
        </Form.Group>

        <Form.Group>
          <Form.Label> کد پستی: </Form.Label>
          <Form.Control
            type="text"
            name=""
            value={address.postCode ?? ""}
            readOnly={true}
          />
        </Form.Group>

        <Form.Group>
          <Form.Label>
            استان:<span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            value={address.province_name.faName}
            readOnly={true}
          />
        </Form.Group>

        <Form.Group>
          <Form.Label>
            شهر:<span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            value={address.city_name.faName}
            readOnly={true}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>
            منطقه:<span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            value={address.area?.faName ?? ""}
            readOnly={true}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>
            آدرس:<span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            as="textarea"
            name=""
            value={address.address}
            readOnly={true}
          />
        </Form.Group>
      </Col>

      {senderOrGetterPick !== -1 && (
        <NewAddress
          senderOrgetter={senderOrGetterPick}
          onClose={number => {
            setSenderOrGetterPick(() => number);
          }}
          setResult={item => {
            setAddress(() => item.address);
            setSenderOrGetterPick(() => -1);
          }}
        />
      )}

      {searchAddressModal !== -1 && (
        <SearchAddress
          close={() => setSearchAddressModal(-1)}
          senderOrgetther={searchAddressModal}
          setAddress={result => setAddress(() => result.address)}
          setNewAddress={() => setSenderOrGetterPick(searchAddressModal)}
        />
      )}

      <Modal show={showModalWarning} direction="rtl">
        <Modal.Header className="d-flex align-item-center justify-content-center">
          <Modal.Title>توجه</Modal.Title>
        </Modal.Header>
        <Modal.Body
          className="d-flex align-item-center justify-content-center text-right "
          style={{ textAlign: "right", direction: "rtl" }}
        >
          <Form className="w-100">
            <Row>
              <p style={{ fontSize: "17px" }}>
                شما در حال ثبت سفارش برای دیگران هستید، کلیه مسئولیت های ارسال
                بار غیرمجاز و خلاف مقررات بعهده دارنده پنل کاربری می باشد.
              </p>
            </Row>
            <Modal.Footer className="d-flex align-item-center justify-content-center">
              <Button
                className="btn-success-style"
                onClick={() => {
                  setShowModalWarning(false);
                  setSearchAddressModal(0);
                }}
              >
                قبول
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
}
export default Address;
